(function(factory) {
  'use strict';
  var offer = factory();
  if (typeof module === 'object' && module.exports) { module.exports = offer; return; }
  if (window.KinsoraOffer) return;
  window.KinsoraOffer = offer;
  var lastCart = null;
  var scheduled = false;

  function money(cents) {
    if (window.Kinsora && window.Kinsora.formatMoney) return window.Kinsora.formatMoney(cents);
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
    }).format(cents / 100);
  }
  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }
  function refresh() {
    scheduled = false;
    var snapshot = document.querySelector('#shopify-section-stack-tier-bar [data-ks-offer-cart]');
    if (!snapshot) return;
    var changed = lastCart !== snapshot.textContent;
    if (changed) {
      try { offer.setCart(JSON.parse(snapshot.textContent)); lastCart = snapshot.textContent; }
      catch (error) { return; }
    }
    document.querySelectorAll('[data-ks-offer-price]').forEach(function(node) {
      var items;
      try { items = JSON.parse(node.getAttribute('data-items')); } catch (error) { return; }
      var result = offer.project(items);
      setText(node.querySelector('[data-ks-offer-current]'), money(result.incrementalPayCents));
      var regular = node.querySelector('[data-ks-offer-regular]');
      var comparison = items.reduce(function(total, item) { return total + Math.max(Number(item.price), Number(item.compareAtPrice || 0)) * Number(item.quantity || 1); }, 0);
      var savings = comparison > result.incrementalPayCents;
      setText(regular, savings ? money(comparison) : '');
      if (regular) regular.hidden = !savings;
    });
    if (changed) document.dispatchEvent(new CustomEvent('kinsora:offer-updated'));
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refresh);
  }
  function relevant(node) {
    return node.nodeType === 1 && (node.matches('[data-ks-offer-cart], [data-ks-offer-price]') || node.querySelector('[data-ks-offer-cart], [data-ks-offer-price]'));
  }
  function start() {
    refresh();
    new MutationObserver(function(records) {
      if (records.some(function(record) {
        return record.target.nodeType === 1 && record.target.matches('[data-ks-offer-cart]') ||
          Array.prototype.some.call(record.addedNodes, relevant);
      })) schedule();
    }).observe(document.body, {childList: true, subtree: true});
  }
  document.addEventListener('kinsora:cart-tier-updated', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})(function() {
  'use strict';
  var cart = [];
  function state(items) {
    var eligible = [];
    var list = 0;
    (items || []).forEach(function(item) {
      var price = Math.max(0, Math.round(Number(item.price) || 0));
      var quantity = Math.max(0, Math.floor(Number(item.quantity == null ? 1 : item.quantity) || 0));
      list += price * quantity;
      if (item.eligible === true && price > 0) {
        for (var i = 0; i < quantity; i += 1) eligible.push(price);
      }
    });
    eligible.sort(function(a, b) { return a - b; });
    var freeCount = 0;
    var savings = eligible.slice(0, freeCount).reduce(function(sum, price) { return sum + price; }, 0);
    return {listCents: list, payCents: list - savings, freeCount: freeCount, eligibleCount: eligible.length};
  }
  // Allocate by unit so duplicate variants and equal prices stay deterministic.
  function allocate(items, current) {
    var rows = (items || []).map(function(item) { return {payCents: 0, listCents: 0, freeQuantity: 0, quantity: 0}; });
    var units = [];
    (current || []).concat(items || []).forEach(function(item, index) {
      var pendingIndex = index - (current || []).length;
      var price = Math.max(0, Math.round(Number(item.price) || 0));
      var quantity = Math.max(0, Math.floor(Number(item.quantity == null ? 1 : item.quantity) || 0));
      if (pendingIndex >= 0) {
        rows[pendingIndex].quantity = quantity;
        rows[pendingIndex].payCents = rows[pendingIndex].listCents = price * quantity;
      }
      if (item.eligible === true && price > 0) {
        for (var i = 0; i < quantity; i += 1) units.push({price: price, pendingIndex: pendingIndex, order: units.length});
      }
    });
    units.sort(function(a, b) { return a.price - b.price || a.order - b.order; });
    units.slice(0, 0).forEach(function(unit) {
      if (unit.pendingIndex < 0) return;
      rows[unit.pendingIndex].payCents -= unit.price;
      rows[unit.pendingIndex].freeQuantity += 1;
    });
    return rows;
  }
  function project(items, currentCart) {
    var current = currentCart || cart;
    var before = state(current);
    var after = state(current.concat(items || []));
    var pending = state(items);
    var allocations = allocate(items, current);
    return {
      incrementalPayCents: Math.max(0, after.payCents - before.payCents),
      pendingListCents: pending.listCents,
      allocations: allocations,
      cartAdjustmentCents: after.payCents - before.payCents - allocations.reduce(function(sum, row) { return sum + row.payCents; }, 0),
      eligible: pending.eligibleCount > 0,
      before: before, after: after
    };
  }
  function purchaseItems(primary, extras) {
    var items = (primary || []).map(function(item) {
      return Object.assign({}, item, {role: 'primary', fullPrice: item.price, properties: {}});
    });
    (extras || []).forEach(function(extra) {
      (extra.offerItems || []).forEach(function(item) {
        items.push(Object.assign({}, item, {role: 'extra', fullPrice: item.price, properties: {}}));
      });
    });
    return items;
  }
  return {state: state, project: project, purchaseItems: purchaseItems, setCart: function(items) { cart = Array.isArray(items) ? items.slice() : []; }};
});

